import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {
  PriceReportPreviewResponseBody,
  SalesPriceReportResponseBody,
  CreatePriceReportResponseBody,
} from '../types';

export const priceReportsMock: SalesPriceReportResponseBody[] = [
  {
    id: 'report-1',
    requestId: 'request-1',
    url: 'https://example.com/report-1.pdf',
    country: 'CZE',
    createdAt: '2024-01-15T10:00:00.000Z',
    createdBy: 'test-user-id',
    sellingPrice: 250000,
    sellingPriceCurrency: 'CZK',
    sellingPriceMin: 230000,
    sellingPriceMinCurrency: 'CZK',
    sellingPriceMax: 270000,
    sellingPriceMaxCurrency: 'CZK',
    purchasePrice: 200000,
    purchasePriceCurrency: 'CZK',
    turnover: 39,
    featuresLevel: 0.72,
    attractivenessScore: 0.62,
    priceDynamics: 'PRICE_DYNAMICS_STABLE',
    marketSituation: 'MARKET_SITUATION_SURPLUS',
  },
  {
    id: 'report-2',
    requestId: 'request-2',
    url: 'https://example.com/report-2.pdf',
    country: 'DEU',
    createdAt: '2024-01-10T10:00:00.000Z',
    createdBy: 'test-user-id',
    sellingPrice: 10000,
    sellingPriceCurrency: 'EUR',
    purchasePrice: 8000,
    purchasePriceCurrency: 'EUR',
    turnover: null,
    featuresLevel: null,
    attractivenessScore: null,
    priceDynamics: null,
    marketSituation: null,
  },
  {
    id: 'report-3',
    requestId: 'request-3',
    url: 'https://example.com/report-3.pdf',
    country: 'CZE',
    createdAt: '2024-01-05T10:00:00.000Z',
    createdBy: 'test-user-id',
  },
];

export const priceReportPreviewMock: PriceReportPreviewResponseBody = {
  stock: 15,
  sold: 25,
  recommendedSellingPrice: {
    amount: '25000',
    currency: 'CZK',
  },
};

export const createdPriceReportMock: CreatePriceReportResponseBody = {
  id: 'new-report-id',
  url: 'https://example.com/new-report.pdf',
  country: 'CZE',
  createdAt: new Date().toISOString(),
};

const getVehiclePriceReportsResponseInterceptor = (
  server: SetupServerApi,
  mockData: SalesPriceReportResponseBody[] = priceReportsMock
) => server.use(http.get('*/dms/v*/vehicle/*/price-report', () => HttpResponse.json(mockData)));

const createVehiclePriceReportPreviewResponseInterceptor = (
  server: SetupServerApi,
  mockData: PriceReportPreviewResponseBody = priceReportPreviewMock
) =>
  server.use(
    http.post('*/dms/v*/vehicle/*/price-report-preview', () => HttpResponse.json(mockData))
  );

const createVehiclePriceReportResponseInterceptor = (
  server: SetupServerApi,
  mockData: CreatePriceReportResponseBody = createdPriceReportMock
) => server.use(http.post('*/dms/v*/vehicle/*/price-report', () => HttpResponse.json(mockData)));

export const vehicleApiMock = {
  priceReportsMock,
  priceReportPreviewMock,
  createdPriceReportMock,
  getVehiclePriceReportsResponseInterceptor,
  createVehiclePriceReportPreviewResponseInterceptor,
  createVehiclePriceReportResponseInterceptor,
};
